import { Pipe, PipeTransform } from '@angular/core';
import { Types } from '../shared/type-constants';

@Pipe({
  name: 'buildingType',
})
export class BuildingTypePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    const roomType = Types.BUILDING_TYPES.find((x) => x.value === value);
    return roomType ? roomType.name : value.charAt(0).toUpperCase() + value.substring(1);
  }
}
